import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/en-gb';

dayjs.extend(relativeTime);
dayjs.locale('en-gb');

@Pipe({
    name: 'timeAgo',
    standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: string | Date): string {
        return dayjs(value).fromNow();
    }
}
